module.exports = __webpack_public_path__ + "static/media/jenni-lee-lose.cd3efe2b.jpg";